import { Component, OnInit } from '@angular/core';
import { WMAIApiService, Language } from './../../core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService, EvtSignIn } from '../../core/services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { WgisService } from '../../wgis/wgis.service';

declare var $: any;

@Component({
  selector: 'site-header',
  templateUrl: './site-header.component.html',
  styleUrls: ['./site-header.component.css']
})
export class SiteHeaderComponent implements OnInit {

  public isUserLoggedIn = false;
  private username: string;
  selectedLanguage: string;
  currentUrl: string;
  languages: Language[] = [];

  constructor(
    private auth: AuthService,
    private router: Router,
    private wmaiservice: WMAIApiService,
    private translateService: TranslateService,
    private wgisservice: WgisService,
    ) {
      this.isUserLoggedIn = this.auth.isUserLoggedIn();
      auth.usersignedin.subscribe(
        (user: string) => {
          this.username = user;
          this.isUserLoggedIn = true;
        }
      );
      auth.userlogout.subscribe(
        () => {
          this.username = '';
          this.isUserLoggedIn = false;
        }
      );
      auth.userislogin.subscribe(
        (data: EvtSignIn) => {
          this.username = data.userid;
          this.isUserLoggedIn = true;
          this.selectedLanguage = data.locale;
          this.changeLanguage(this.selectedLanguage);
        }
      );
    }

  ngOnInit() {

    $('.ui.dropdown').dropdown();
    $('.ui.sticky').sticky({context: '#menuheader'});

    this.wmaiservice.getLanguages().subscribe(data => {
      let lang: string[] = [];
      for (let i = 0; i < data.length; i++) {
        lang.push(data[i].val);
        let tmp: Language = new Language(data[i].cat, data[i].val);
        this.languages.push(tmp);
      }
      this.translateService.addLangs(lang);
    });

    this.selectedLanguage = localStorage.getItem('locale') || 'it';
    this.translateService.setDefaultLang(this.selectedLanguage);

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
      }
    });

    this.auth.ctrLogIn();
  }
  /**
   * Cambia la lingua di tutto il servizio in base al parametro passato
   * @param  {string} language
   */
  changeLanguage(language: string): void {
    localStorage.setItem('locale', language);
    this.selectedLanguage = language;
    if (this.isUserLoggedIn) {
      this.wmaiservice.setLanguage(this.username, this.selectedLanguage);
    }

    this.translateService.use(this.selectedLanguage);
    this.auth.usersetlanguage.emit();
  }

  logout(e) {
    e.preventDefault();
    this.auth.logout();
    this.router.navigateByUrl('/');
    this.isUserLoggedIn = false;
  }
  
  displaymap() {
    // this.wgisservice.wgisVisible.emit(true)
    this.wgisservice.cmdToggleMap();
  }
}